<template>
  <div class="settings-overlay" :class="{ open: visible }" @click.self="$emit('close')">
    <div class="settings-panel">
      <div class="settings-panel-header">
        <span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-3px;margin-right:6px">
            <circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
          </svg> 设置
        </span>
        <button @click="$emit('close')">×</button>
      </div>
      <div class="settings-panel-body">
        <div class="settings-item">
          <div>
            <div class="si-label">深色模式</div>
            <div class="si-desc">当前：{{ portal.state.theme === 'dark' ? '暗色' : '亮色' }}主题</div>
          </div>
          <label class="toggle-switch">
            <input type="checkbox" :checked="portal.state.theme === 'light'" @change="portal.toggleTheme()">
            <span class="slider"></span>
          </label>
        </div>
        <div class="settings-item">
          <div>
            <div class="si-label">导出对话记录</div>
            <div class="si-desc">支持 HTML、Markdown、JSON、TXT 格式</div>
          </div>
          <div style="display:flex;gap:6px;flex-wrap:wrap">
            <button class="settings-btn export-btn" @click="exportConv('html')">HTML</button>
            <button class="settings-btn export-btn" @click="exportConv('markdown')">Markdown</button>
            <button class="settings-btn export-btn" @click="exportConv('json')">JSON</button>
            <button class="settings-btn export-btn" @click="exportConv('txt')">TXT</button>
          </div>
        </div>
        <button class="settings-btn" @click="$emit('openContentPage', 'terms')">用户协议</button>
        <button class="settings-btn" @click="$emit('openContentPage', 'privacy')">隐私政策</button>
        <div class="settings-version">{{ versionText }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { usePortal } from '@/stores/portal'
import { globalToast } from '@/composables/useToast'
import { PORTAL_CONFIG } from '@/config'

defineProps<{ visible: boolean }>()
defineEmits<{ close: []; openContentPage: [type: 'terms' | 'privacy'] }>()

const portal = usePortal()
const config = PORTAL_CONFIG

const versionText = computed(() => {
  const v = portal.state.siteConfig?.version || config.API_VERSION
  return v ? 'v' + v : ''
})

async function exportConv(format: string) {
  try {
    const token = portal.getToken()
    const convId = portal.state.currentConversationId
    const url = `/api/dashboard.php?action=export_conversation&format=${format}` +
      (convId ? `&request_id=${convId}` : '')
    const res = await fetch(url, {
      headers: { Authorization: 'Bearer ' + token },
    })
    if (!res.ok) throw new Error('导出失败')
    const blob = await res.blob()
    const downloadUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = downloadUrl
    a.download = `conversation_export.${format === 'markdown' ? 'md' : format}`
    a.click()
    URL.revokeObjectURL(downloadUrl)
    globalToast('导出成功', 'success')
  } catch (e: any) {
    globalToast('导出失败: ' + e.message, 'error')
  }
}

</script>
